import React from 'react';
import useGameStore from '../engine/store';

export default function MenuScreen() {
  const { startNegotiation, goToCareer, careerScore, dealsCompleted } = useGameStore();

  return (
    <div className="min-h-screen bg-dark-900 bg-grid flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-14 animate-slide-up">
          <div className="text-7xl mb-5">🤝</div>
          <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-yellow via-neon-orange to-neon-red leading-tight">
            Negotiation
          </h1>
          <h1 className="text-5xl md:text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-neon-blue via-neon-purple to-neon-green leading-tight -mt-2">
            Master
          </h1>
          <p className="text-gray-400 mt-4 text-lg max-w-md mx-auto">
            Read your opponent. Time your moves. Close the deal.
          </p>
        </div>

        {/* How it works */}
        <div className="glass-panel p-6 mb-8 animate-slide-up" style={{ animationDelay: '0.15s' }}>
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-3xl mb-2">🎯</div>
              <div className="text-sm font-semibold text-white">Negotiate</div>
              <div className="text-xs text-gray-500 mt-1">Make offers, bluff, apply pressure</div>
            </div>
            <div>
              <div className="text-3xl mb-2">🧠</div>
              <div className="text-sm font-semibold text-white">Read the AI</div>
              <div className="text-xs text-gray-500 mt-1">Each opponent has a unique personality</div>
            </div>
            <div>
              <div className="text-3xl mb-2">💰</div>
              <div className="text-sm font-semibold text-white">Close Deals</div>
              <div className="text-xs text-gray-500 mt-1">Score based on value, speed, and skill</div>
            </div>
          </div>
        </div>

        {/* Career stats */}
        {dealsCompleted > 0 && (
          <div className="glass-panel p-4 mb-6 animate-slide-up" style={{ animationDelay: '0.2s' }}>
            <div className="flex items-center justify-between">
              <div>
                <div className="text-xs text-gray-500 uppercase tracking-wider">Career Score</div>
                <div className="text-2xl font-black font-mono text-neon-yellow">{careerScore.toLocaleString()}</div>
              </div>
              <div className="text-right">
                <div className="text-xs text-gray-500">Deals Closed</div>
                <div className="text-lg font-bold text-neon-green">{dealsCompleted}</div>
              </div>
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="flex flex-col items-center gap-4 animate-slide-up" style={{ animationDelay: '0.25s' }}>
          <button
            onClick={() => startNegotiation()}
            className="btn-primary text-lg px-14 py-5 w-full sm:w-auto text-center"
          >
            🤝 Start Negotiation
          </button>

          {dealsCompleted > 0 && (
            <button
              onClick={goToCareer}
              className="btn-secondary text-sm px-8 py-3"
            >
              📊 Career Stats
            </button>
          )}
        </div>

        {/* Keyboard hint */}
        <div className="text-center mt-8 text-xs text-gray-600 animate-slide-up" style={{ animationDelay: '0.3s' }}>
          Tip: Use number keys 1-6 during negotiation for quick actions
        </div>
      </div>
    </div>
  );
}
